import { render } from "./ReviewPersonalInfo.vue?vue&type=template&id=2ed1fa91"
import script from "./ReviewPersonalInfo.vue?vue&type=script&lang=js"
export * from "./ReviewPersonalInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__